// Datos de donación (direcciones/alias PÚBLICAS de recepción).
// Podés ir sumando más métodos al array DONACIONES.

export const MP_ALIAS = "mai1209.mp";

export const DONACIONES = [
  {
    id: "mp",
    icono: "mp",
    titulo: "Mercado Pago",
    desc: "Transferencia en pesos (ARS). Copiá el alias y pegalo en Mercado Pago.",
    valor: "mai1209.mp",
  },
  {
    id: "usdt",
    icono: "eth",
    titulo: "USDT / ETH · Ethereum (ERC-20)",
    desc: "Misma dirección para USDT o ETH en la red Ethereum. Enviá solo por red compatible.",
    valor: "0xb06fBA7Ab85837ED74f125B1c4237fd94a801626",
  },
  {
    id: "btc",
    icono: "btc",
    titulo: "Bitcoin (BTC)",
    desc: "Dirección de Bitcoin, red Bitcoin.",
    valor: "bc1qlrchf2lly2rz220nls2a7596c4pld7j0qr7pv3",
  },
  {
    id: "astropay",
    icono: "astropay",
    titulo: "AstroPay",
    desc: "Alias de AstroPay.",
    valor: "maicodex",
  },
];
